import { CommonModule } from "@angular/common";
import { Component, inject, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslatePipe } from "@ngx-translate/core";

import { Constants } from "../../../constants/constants";
import { ProjectComment } from "../../../models";
import { CommentsComponent } from "../../general";

@Component({
  selector: "adaa-tp-comments-modal",
  imports: [TranslatePipe, CommonModule, CommentsComponent],
  templateUrl: "./tp-comments-modal.html",
  styleUrl: "./tp-comments-modal.scss",
})
export class TpCommentsModalComponent {
  modal: NgbActiveModal = inject(NgbActiveModal);

  @Input() comments: ProjectComment[];

  constants = Constants;
}
